<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="交易日期" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="币种" prop="orderType">
        <el-select v-model="form.orderType" placeholder="请选择币种">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单据类型" prop="bs">
        <el-select v-model="form.bs" placeholder="请选择单据类型">
          <el-option
            v-for="item in bsArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营组织" prop="orderNum">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="deptName">
        <search-select
          v-model="form.custom"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="tradingNo"
        label="交易流水号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="tradingDate"
        label="交易日期"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="tradingTime"
        label="交易时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="code"
        label="交易方向"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.tradingAmount > 0">收</span>
          <span v-else >付</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bsStr"
        label="单据类型"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="tradingCurrency"
        label="交易币种"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.tradingCurrency == '1'">CNY</span>
          <span v-show="scope.row.tradingCurrency == '2'">USD</span>
          <span v-show="scope.row.tradingCurrency == '3'">EUR</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tradingAmount"
        label="交易金额"
        :formatter="logisticsModeFormat"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="mark"
        label="备注"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="payAccountName"
        label="付款户名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="payAccountNo"
        label="付款账号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="gatheringAccountName"
        label="收款户名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="gatheringAccountNo"
        label="收款账号"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'
import { mapActions } from 'vuex'
export default {
  name: 'saleQuery',
  components: { AjaxSelect, MultiCascader, SearchSelect },
  data () {
    return {
      form: {
        tareWeightTime: []
      },
      // 订单类型
      typeArr: [
        { value: '', label: '全部' },
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      // 单据类型
      bsArr: [
        { value: '', label: '全部' },
        { value: 0, label: '银行存款' },
        { value: 1, label: '应收票据' }
      ],
      citisOptions: [],
      tableData: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      }
    }
  },
  methods: {
    ...mapActions([
      'getApplicationList'
    ]),
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk', this.form.tareWeightTime.length)
      const params = {
        orgId: this.form.organization,
        customerId: this.form.custom,
        currencyType: this.form.orderType,
        bs: this.form.bs,
        // startDate: this.form.tareWeightTime[0].substring(0, 10),
        // endDate: this.form.tareWeightTime[1].substring(0, 10),
        ...this.listState
      }
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime.length === 2) {
        params.createTimeStart = this.form.tareWeightTime[0].substring(0, 10)
        params.createTimeEnd = this.form.tareWeightTime[1].substring(0, 10)
        console.log(params)
      }
      console.log('8888')
      this.getApplicationList(params).then(res => {
        console.log(res, '8888')
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        console.log(this.tableData)
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.custom = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
